module.exports = __webpack_public_path__ + "static/media/download.41bb4c64.svg";